/**
 * 內容保護島嶼 —— 禁止右鍵選單與文字選取。
 *
 * 業主 2026-08-31 指示保留此功能。舊站的對應實作是
 * `/scripts/funprotect.js`，只在 `/news/`、`/wine/`、`/video/` 三個區塊載入。
 *
 * ⚠️ **這是嚇阻，不是保護。** 內容仍可透過檢視原始碼、開發者工具、
 *    停用 JavaScript、或直接對網址發請求取得。伺服器端無法阻止這些。
 *    保留它的價值在於降低隨手複製的比例，而不是真的擋住有意取用的人。
 *
 * ⚠️ **這會讓載入它的頁面不再是「零 JS」**（規格 10.2）。
 *    因此刻意做成島嶼、且**只掛在需要的頁面**，不進全站 Layout。
 *    壓縮後約 0.4 kB。
 *
 * 相容性上刻意沿用舊站的兩個決定：
 *   1. 表單欄位（input / textarea / select）不受影響 —— 否則使用者無法編輯輸入
 *   2. **不攔 mousedown** —— 舊站註解記載那會讓 Chrome 的下拉選單失效
 */

const FORM_TAGS = new Set(['input', 'textarea', 'select', 'option']);

/**
 * 除錯用的繞道。沿用舊站的 `?EnableRightClick` 參數名 ——
 * 客服與維運習慣了這個開關，換名字只會造成溝通成本。
 */
function isBypassed(): boolean {
  return new URLSearchParams(window.location.search).has('EnableRightClick');
}

/** 目標是否為可編輯區域。可編輯區被擋住會讓使用者根本無法輸入。 */
function isEditable(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) {
    return false;
  }

  if (FORM_TAGS.has(target.tagName.toLowerCase())) {
    return true;
  }

  // contenteditable 的子孫節點也要放行
  return target.closest('[contenteditable="true"]') !== null;
}

function block(event: Event): void {
  if (isEditable(event.target)) {
    return;
  }

  event.preventDefault();
}

if (!isBypassed()) {
  document.addEventListener('contextmenu', block);
  document.addEventListener('selectstart', block);
}
